import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getGiros, getEstados } from '../../actions/TablaBuquesAnunciadosActions'
import TablaBuquesAnunciadosView from '../../components/anunciobuques/TablaBuquesAnunciadosView'

const TablaBuquesAnunciados = (props) => {
  useEffect(() => {
    async function getData () {
      props.getGiros()
      props.getEstados()
    }
    getData()
  }, [props])

  return (
    <>
      <TablaBuquesAnunciadosView />
    </>
  )
}

const mapActionsToProps = {
  getGiros,
  getEstados
}

export default connect(null, mapActionsToProps)(TablaBuquesAnunciados)
